import { Lookup } from 'devextreme-react/data-grid';
import React from 'react';

export const RenderLookup = (values: any[] = []) => (
  <Lookup dataSource={values} displayExpr="display_name" valueExpr="uri" />
);
